var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclematory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3049",
    d: "M15 20.7279C16.759 20.7279 18.5181 20.7279 20.2771 20.7279C20.2771 22.1394 20.2771 23.551 20.2771 24.9626C18.5181 24.9626 16.759 24.9626 15 24.9626C15 23.551 15 22.1394 15 20.7279ZM15 10C16.759 10 18.5181 10 20.2771 10C20.2771 12.9172 20.2771 15.8345 20.2771 18.7517C18.5181 18.7517 16.759 18.7517 15 18.7517C15 15.8345 15 12.9172 15 10Z",
    fill: "#DC3546"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1382",
    cx: 17.5,
    cy: 17.5,
    r: 17,
    stroke: "#DC3546"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclematory);
export default __webpack_public_path__ + "static/media/exclematory.6cc067f69802ccb5500ac19771698335.svg";
export { ForwardRef as ReactComponent };